import type { QualityRole } from '../types/content';

export const deliverySteps = [
  {
    title: 'Plan & mobilise',
    text: 'The project manager mobilises the design review and construction teams and subcontractors, and coordinates the contract document review.',
  },
  {
    title: 'Supervise on site',
    text: 'A full-time site agent supervises field personnel so the works are built to the contract plans and specifications.',
  },
  {
    title: 'Inspect, test & verify',
    text: 'Site inspections, testing procedures and survey checks confirm line, level, size and dimensions within the specified tolerances.',
  },
  {
    title: 'Record & hand over',
    text: 'Daily records, payment certificates, as-built drawings and completion records support verification and handover.',
  },
];

export const qualityProcedures = [
  'Duties and responsibilities of site staff',
  'Daily records',
  'Site inspections',
  'Testing procedures and frequencies',
  'Monitoring progress',
  'Cash flow',
  'Payment certificates',
  'As-built drawings',
  'Completion records',
];

export const projectRoles: QualityRole[] = [
  {
    title: "Project Manager (Contractor's Representative)",
    summary:
      'Leads the overall organisation, planning and activity of the construction team, makes sure the project is carried out according to the contract documentation, and stays in contact with the client throughout.',
    responsibilities: [
      'Mobilise the design review and construction teams and subcontractors, including quality management programmes',
      'Coordinate contract document review so client and stakeholder requirements are implemented accurately',
      'Carry out periodic reviews of the site team’s technical performance',
      'Provide technical back-up and information transfer from head office',
      'Select short-term expert consultants for specialised inputs where needed',
    ],
  },
  {
    title: 'Site Agent',
    summary:
      'Works on site full-time, monitoring every phase of construction and supervising field personnel. Is the administrative head of the contractor’s site office.',
    responsibilities: [
      'Maintain correspondence records, site files and document and drawing issues',
      'Manage safety, quality control and environmental issues throughout construction',
      'Plan and manage materials procurement, delivery, storage and installation',
      'Monitor expenditure, cash flow and progress against programme',
      'Liaise with the client’s staff and prepare monthly and quarterly progress reports',
      'Verify completed work for payment purposes',
    ],
  },
  {
    title: 'Surveyor',
    summary: 'Sets out and verifies the works so construction matches the specified geometry.',
    responsibilities: [
      'Ensure correct siting of site establishment',
      'Validate setting out of the works from beacons and reference pegs',
      'Verify line, level, size and dimension compliance within specified tolerances',
      'Assist with measurement of works',
      'Complete as-built drawings with inputs on lines and levels',
    ],
  },
  {
    title: 'Safety, Health & Environment Officer',
    summary:
      'The profile commits to appointing a full-time SHE officer, who manages near-miss capture, close-out and risk assessment for tasks that could cause injury, property damage or environmental impact.',
    responsibilities: [
      'Identify, eliminate and control safety risks in the workplace and the environment',
      'Identify training needs so tasks are performed by qualified, competent personnel',
      'Implement relevant mining, building and construction regulations and safe operating procedures',
      'Lead incident and accident investigations and corrective actions',
      'Ensure provision and use of appropriate personal protective equipment',
      'Carry out medical surveillance through pre-employment, periodic and exit assessments',
      'Conserve environmental resources and minimise adverse impacts from operations',
    ],
  },
];
